/**
 * RTWO Native Currency Engine — Public API
 * Phase 14.5 | Module ID: RTWO-NATV-001
 * Version: 1.0.0-phase14.5
 *
 * Public exports for the RTWO Native Currency Engine.
 * Import from this file for all Native Currency Engine functionality.
 *
 * Truthful Data Policy:
 * - No fake RTWO supply, market cap, price, treasury balance, validator rewards,
 *   staking supply, or allocations.
 * - RTWO currency is NOT claimed as live.
 *
 * Source: Native Currency Engine (RTWO-NATV-001)
 */

// Domain Models
export type {
  CurrencyId,
  PolicyId,
  SupplyStateId,
  AllocationId,
  FeePolicyId,
  ScheduleId,
  EventId,
  ParameterId,
  NATVTimestamp,
  RTWONativeCurrencyEngineStatus,
  RTWONativeCurrencyLifecycleStage,
  RTWOCurrencyType,
  RTWONativeCurrencyStatus,
  RTWOSupplyModel,
  RTWOIssuancePolicy,
  RTWOBurnPolicy,
  RTWOInflationPolicy,
  RTWODeflationPolicy,
  RTWOMonetaryPolicyStatus,
  RTWOSupplyStateStatus,
  RTWOAllocationType,
  RTWOAllocationPolicyStatus,
  RTWOBaseFeePolicy,
  RTWOPriorityFeePolicy,
  RTWOBurnFeePolicy,
  RTWOValidatorFeePolicy,
  RTWOFeePolicyStatus,
  RTWOEmissionType,
  RTWOEmissionScheduleStatus,
  RTWONativeCurrencyEventType,
  RTWONativeCurrencyEventStatus,
  RTWOParameterType,
  RTWOParameterStatus,
  NATVEventType,
  NATVEventHandler,
  RTWONativeCurrency,
  RTWOMonetaryPolicy,
  RTWOSupplyState,
  RTWOAllocationPolicy,
  RTWOFeePolicy,
  RTWOEmissionSchedule,
  RTWONativeCurrencyEvent,
  RTWOProtocolEconomicParameter,
} from './domain-models';

export {
  NATV_ENGINE_VERSION,
  NATV_ENGINE_STATUS_LABELS,
  NATV_LIFECYCLE_LABELS,
  NATV_LIFECYCLE_DESCRIPTIONS,
  CURRENCY_TYPE_LABELS,
  ALLOCATION_TYPE_LABELS,
  EMISSION_TYPE_LABELS,
  PARAMETER_TYPE_LABELS,
  RTWO_ECONOMIC_PARAMETERS,
} from './domain-models';

// Service Interfaces
export type {
  NATVServiceStatus,
  NATVServiceDescriptor,
  NATVServiceRegistry,
  INATVService,
  INativeCurrencyRegistryService,
  NativeCurrencyRegistryResult,
  IMonetaryPolicyService,
  MonetaryPolicyResult,
  ISupplyStateService,
  SupplyStateResult,
  IAllocationPolicyService,
  AllocationPolicyResult,
  IFeePolicyService,
  FeePolicyResult,
  IEmissionScheduleService,
  EmissionScheduleResult,
  IEconomicParameterService,
  EconomicParameterResult,
  INativeCurrencyEventPublisherService,
  NativeCurrencyEventPublishResult,
  INativeCurrencyValidationService,
  NativeCurrencyValidationResult,
  INativeCurrencyReadinessService,
  NATVReadinessReport,
} from './service-interfaces';

// Engine
export { RTWONativeCurrencyEngine } from './native-currency-engine';
export { getNativeCurrencyEngine } from './native-currency-engine';
